<template>
  <div class="product-cart-progress">
    <div class="product-cart-progress__spinner"></div>
  </div>
</template>

<script>
export default {
  name: 'product-cart-progress',
};
</script>

<style lang="scss">
@import './product-cart-progress';
</style>
